<template>
    <div class="icons-wrapper flex flex-row flex-wrap  justify-center -mr-3 sm:-mr-8 -mb-4">
        <div v-for="(option, index) in options" :key="`option-${index}`" 
            class="option-icon p-4 pt-1 pb-2 border-2 border-black  hover:border-orange flex flex-col box-border justify-center self-stretch 
                   content-center cursor-pointer items-center relative  mb-4 mr-4 last:mr-0 sm:mb-8 last:sm:mr-0 sm:mr-8 w-1/3"
            :class="{
                'border-orange selected': selected && (selected === option || selected === option.value), 
            }"
            :style="{
                width: '165px',
                height: '165px',
            }"
            @click="$emit('Select', option)"
        >
            <div class="absolute right-0 top-0">
                <div v-if="selected === option" class="bg-orange cbox-wrapper" style="width: 25px; height: 25px"><span class="checkmark"/></div>
            </div>
            
            <!-- <img class="w-full h-auto" :src="img_url(option)" :width="size" :height="size"/> -->
            <!-- <img v-if="option.icon_mode !== 'fit'" class="w-75p h-75p mdlg:w-100p mdlg:h-100p lg:w-150p lg:h-150p" :src="img_url(option)" :width="size" :height="size"/> -->
            <!-- <div v-else class="h-75p md:h-100p lg:h-150p flex items-center">
                <img  class="w-75p md:w-100p  lg:w-150p h-auto" :src="img_url(option)" :width="size" :height="size"/>
            </div> -->
            <span class="option-name   box-content flex items-end justify-center  w-full h-full"
                :style="{
                    'background-image' : `url(${img_url(option)})`,
                    'background-size': option.icon_mode === 'fit' ?  '80%' : '100% auto' ,
                    'background-repeat' : 'no-repeat',
                    'background-position': option.icon_mode === 'fit' ? 'center center': '50% 20%',
                    

                }"
            >
            </span>
            <span class="font-bold">{{option.name || option.label}}</span>
        </div>
        <slot/>
    </div>
</template>
<script>
const url_prefix='';
export default {
    props: ['options', 'selected', 'width'],
    methods: {
        img_url(option) {
            if (option.image_selected && option.value === this.selected) return option.image_selected;
            return option.icon_url || option.image || `${url_prefix}imgs/${option.name.replace(' ', '_').toLowerCase()}.png`
        }
    },
    computed: {
        size() {
            return this.width || 150
        },

        img_style() {
            return {
                width: `${this.size}px`,
                height: `${this.size}px`,
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.cbox-wrapper {
  display: block;
  position: relative;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  min-width: 25px;
  min-height: 25px;
}

.icons-wrapper {
    // max-width: 300px;

    // @media screen and (min-width: 380px) {
    //     max-width: 340px;
    // }
    @media screen and (min-width: 450px) {
        max-width: 620px;
    }
}

.option-icon {
      width: 100%;
      height: auto;
      min-height: 124px;
    @media screen and (min-width: 372px) {
        width:  124px;
        height: 124px;
    }
    // height: 100%;
    // @screen xs {
    //     width: 124px;
    //     height: 124px;

    // }

    // @screen md {
    //     width: 174px;
    //     height: 174px;
    // }
}



</style>